import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

export namespace SharedViewsPopupStyle {

  export const sharedViewsPopupCssPrefix = 'SharedViewsPopup';

  export const SpinnerContainer = cssClass(sharedViewsPopupCssPrefix, 'container-spinner', {
    margin: '16px',
  });

  export const ContentContainer = cssClass(sharedViewsPopupCssPrefix, 'container-content', {
    lineHeight: '1.5em',
    maxHeight: '300px',
    overflowY: 'scroll',
    padding: '16px 0px',
    width: '320px',
    $nest: {
      '> p': {
        margin: '0px 16px',
      },
    }
  });

  export const Title = cssClass(sharedViewsPopupCssPrefix, 'title', {
    color: applyColor(DesignTokens.color.font.default.default, '#333333'),
    fontSize: '16px',
    fontWeight: 'normal',
    margin: '0px 16px 24px 16px',
  });

  export const SharedViewsList = cssClass(sharedViewsPopupCssPrefix, 'shared-views-list', {
    marginTop: '12px',
    wordBreak: 'break-word',
  });

  export const SharedViewContainer = cssClass(sharedViewsPopupCssPrefix, 'shared-view-container', {
    display: 'flex',
    padding: '12px 16px',
    $nest: {
      '&:hover': {
        backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#F5F5F5'),
      },
    }
  });

  export const SharedViewDetails = cssClass(sharedViewsPopupCssPrefix, 'shared-view-details', {
    flexDirection: 'column',
  });

  export const SharerName = cssClass(sharedViewsPopupCssPrefix, 'sharer-name', {
    fontWeight: 'bold',
  });

  export const SharedAt = cssClass(sharedViewsPopupCssPrefix, 'shared-at', {
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.Grey102),
  });

  export const Message = cssClass(sharedViewsPopupCssPrefix, 'message', {
    marginTop: '16px',
  });

  export const ViewLink = cssClass(sharedViewsPopupCssPrefix, 'view-link', {
    marginTop: '10px',
    $nest: {
      'a': {
        textDecoration: 'underline',
      },
      'a:hover': {
        textDecoration: 'none',
      },
    }
  });
}
